import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { logout } from '../../../store/actions/index';

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavLink,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';
import DevDomainSwitcher from '../../../components/DevDomainSwitcher/DevDomainSwitcher';
import { getBrandingContext } from '../../../utils/hostname';

const USP_MARKETING_URL = 'https://www.uniqueservicepartner.pl/';

class NavBar extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  close = () =>
    this.setState({
      isOpen: false
    });

  render() {
    const { hasPrograms, isAuthenticated, luxmed } = this.props;
    const {
      isDevPreviewHost,
      isOrange,
      isInsurances,
      isUbezpieczeniaDev,
      isNais,
      isTvpUbezpieczenia,
      isLanDevelopment,
      showFullDashboard,
      showShooterProtect
    } = getBrandingContext();

    const linksToUspMarketing =
      (isOrange || isInsurances) && (!isAuthenticated || luxmed);

    let profileMenu = null;
    let opis =
      'Specjalna oferta ubezpieczeniowa oraz inne produkty dla pracowników i współpracowników TVP';
    let navbarBackorund = { backgroundColor: '#003c7d' };

    if (isTvpUbezpieczenia || isUbezpieczeniaDev || isLanDevelopment) {
      navbarBackorund = {
        background:
          'linear-gradient(90deg, rgba(52, 52, 113, 1) 0%, rgba(45, 68, 125, 1) 35%, rgba(3, 178, 188, 1) 100%)'
      };
    }

    if (isOrange || isInsurances) {
      opis =
        'Oferta ubezpieczeniowa dla pracowników i współpracowników Grupy Orange';
      navbarBackorund = {
        backgroundColor: '#003c7d',
        fontSize: '2rem'
      };
    }

    if (isInsurances) {
      opis = 'Specjalna oferta ubezpieczeniowa';
    }

    if (isNais) {
      opis = 'Specjalna oferta zdrowotna i ubezpieczeniowa';
      navbarBackorund = {
        backgroundColor: '#ffffff'
      };
    }

    const generateMenu = this.props.menu.map((item) => {
      if (item && item.displayName === 'Profile') {
        profileMenu = item.nestedElements.map((nestedItem) => (
          <Link
            onClick={this.close}
            to={`/${nestedItem.pageId}`}
            key={nestedItem.nodeId}>
            <DropdownItem tag="div" className="userDropdownItem">
              <div className="userDropIcon">
                <FontAwesomeIcon
                  fixedWidth
                  icon={nestedItem.materialIcon || 'dot-circle'}
                />
              </div>
              <div className="userName">{nestedItem.displayName}</div>
            </DropdownItem>
          </Link>
        ));
        return null;
      }
      if (item.nestedElements) {
        return (
          <UncontrolledDropdown key={item.nodeId} nav inNavbar>
            <DropdownToggle
              nav
              caret
              style={{
                color: isNais ? (isNais ? '#212529' : '#003865') : '#ffffff'
              }}>
              {item.displayName}
            </DropdownToggle>
            <DropdownMenu>
              {item.nestedElements.map((nestedItem) => (
                <Link
                  onClick={this.close}
                  to={`/${nestedItem.pageId}`}
                  key={nestedItem.nodeId}>
                  <DropdownItem>{nestedItem.displayName}</DropdownItem>
                </Link>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      } else if (item.pageId) {
        return (
          <NavItem key={item.nodeId}>
            <NavLink
              onClick={this.close}
              tag={RouterNavLink}
              to={`/${item.pageId}`}>
              {item.displayName}
            </NavLink>
          </NavItem>
        );
      }
      return null;
    });
    // const generateMenu = null;

    return (
      <div style={navbarBackorund} className="fixedTop">
        <Navbar dark expand="md" className="fixedWidth">
          <NavbarBrand
            {...(linksToUspMarketing
              ? { tag: 'a', href: USP_MARKETING_URL }
              : { tag: Link, to: '/' })}
            onClick={this.close}
          >
            {(!isAuthenticated || luxmed) && (
              <React.Fragment>
                {(isOrange || isInsurances) && (
                  <img
                    style={{
                      height: '55px',
                      backgroundColor: 'white',
                      marginLeft: '30px'
                    }}
                    src={process.env.PUBLIC_URL + '/usp567noborder.png'}
                    alt="USP logo"
                  />
                )}

                {!isOrange && !isInsurances && !isNais && (
                  <img
                    style={{ height: '50px', padding: '5px 5px 5px 0' }}
                    src={process.env.PUBLIC_URL + '/tvp/tvp-logo.png'}
                    alt="TVP logo"
                  />
                )}

                {isNais && (
                  <img
                    style={{ height: '50px', marginLeft: '30px' }}
                    src={process.env.PUBLIC_URL + '/nais.png'}
                    alt="Nais logo"
                  />
                )}
              </React.Fragment>
            )}
            {isAuthenticated && !luxmed && (
              <img
                style={{
                  height: '50px',
                  backgroundColor: 'white',
                  borderRadius: '4px',
                  marginRight: '0.5rem'
                }}
                src="/public-assets/usp.png"
                alt="USP  logo"
              />
            )}
          </NavbarBrand>

          <NavbarToggler onClick={this.toggle} />

          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav navbar>
              {(!isAuthenticated || luxmed) && (
                <React.Fragment>
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle
                      nav
                      caret
                      style={
                        isOrange || isInsurances
                          ? { fontSize: '1.1em', marginLeft: '10px' }
                          : isNais || isInsurances
                            ? isNais
                              ? {
                                  color: '#39AA2C',
                                  marginLeft: '30px',
                                  fontSize: '1.2em',
                                  fontWeight: 'bolder'
                                }
                              : {
                                  color: '#003865',
                                  marginLeft: '30px',
                                  fontSize: '1.2em',
                                  fontWeight: 'bolder'
                                }
                            : null
                      }>
                      {opis}
                    </DropdownToggle>
                    <DropdownMenu
                      style={isNais ? { marginLeft: '30px' } : null}>
                      <Link onClick={this.close} to="/zagraniczne">
                        <DropdownItem>Podróże zagraniczne</DropdownItem>
                      </Link>

                      <Link onClick={this.close} to="/assistance">
                        <DropdownItem>Moto Assistance</DropdownItem>
                      </Link>

                      <Link onClick={this.close} to="/pethelp">
                        <DropdownItem>Pethelp</DropdownItem>
                      </Link>

                      <Link onClick={this.close} to="/edu">
                        <DropdownItem>NNW szkolne</DropdownItem>
                      </Link>

                      <Link onClick={this.close} to="/majatkowe">
                        <DropdownItem>Majątkowe</DropdownItem>
                      </Link>

                      {!isOrange && !isInsurances && !isNais && (
                        <Link onClick={this.close} to="/komunikacyjne">
                          <DropdownItem>
                            Ubezpieczenie Twojego Auta - Pakiety Dealerskie
                          </DropdownItem>
                        </Link>
                      )}

                      {showShooterProtect && (
                        <a
                          onClick={this.close}
                          href="https://shooterprotect.pl/"
                          target="_blank"
                          rel="noopener noreferrer">
                          <DropdownItem>
                            OC, NNW, Ochrona Prawna - przy pozwoleniu na broń
                          </DropdownItem>
                        </a>
                      )}

                      {showFullDashboard && (
                        <Link onClick={this.close} to="/likwidacja">
                          <DropdownItem>Szkody komunikacyjne</DropdownItem>
                        </Link>
                      )}

                      {showFullDashboard && (
                        <Link onClick={this.close} to="/pracownicy">
                          <DropdownItem>Opieka szpitalna</DropdownItem>
                        </Link>
                      )}

                      {showFullDashboard && (
                        <a
                          onClick={this.close}
                          href="https://tvp-tuwpzuw.uspartner.pl/"
                          target="_blank"
                          rel="noopener noreferrer">
                          <DropdownItem>Zdrowotne</DropdownItem>
                        </a>
                      )}

                      {/* {!isOrange && !isInsurances && !isNais && (
                        <Link onClick={this.close} to="/finanse">
                          <DropdownItem>Finanse</DropdownItem>
                        </Link>
                      )} */}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </React.Fragment>
              )}

              {generateMenu}
            </Nav>
            <Nav className="ml-auto" navbar>
              {this.props.isAuthenticated && (
                <React.Fragment>
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>
                      <FontAwesomeIcon
                        fixedWidth
                        icon="user-circle"
                        style={
                          isNais
                            ? isNais
                              ? { color: '#212529' }
                              : { color: '#003865' }
                            : { color: '#ffffff' }
                        }
                      />
                      <span
                        className="navbarUsername"
                        style={
                          isNais
                            ? isNais
                              ? { color: '#212529' }
                              : { color: '#003865' }
                            : { color: '#ffffff' }
                        }>
                        {this.props.username}
                      </span>
                    </DropdownToggle>
                    <DropdownMenu right className="userDropdown">
                      <div className="userDropdownItem profile">
                        <div className="userDropIcon">
                          <FontAwesomeIcon fixedWidth icon="user-circle" />
                        </div>
                        <div className="userName">{this.props.username}</div>
                      </div>
                      {hasPrograms && (
                        <Link onClick={this.close} to="/changeprogram/">
                          <DropdownItem tag="div" className="userDropdownItem">
                            <div className="userDropIcon">
                              <FontAwesomeIcon fixedWidth icon="exchange-alt" />
                            </div>
                            <div className="userName">Zmień program</div>
                          </DropdownItem>
                        </Link>
                      )}
                      {profileMenu}
                      <Link onClick={this.close} to="/change-password/">
                        <DropdownItem
                          tag="div"
                          onClick={() => {
                            this.close();
                          }}
                          className="userDropdownItem">
                          <div className="userDropIcon">
                            <FontAwesomeIcon fixedWidth icon="key" />
                          </div>
                          <div className="userName">Zmień hasło</div>
                        </DropdownItem>
                      </Link>
                      <DropdownItem
                        tag="div"
                        onClick={() => {
                          this.close();
                          this.props.logout();
                        }}
                        className="userDropdownItem">
                        <div className="userDropIcon">
                          <FontAwesomeIcon fixedWidth icon="sign-out-alt" />
                        </div>
                        <div className="userName">Wyloguj się</div>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </React.Fragment>
              )}
              {isDevPreviewHost && (
                <NavItem className="d-flex align-items-center ml-3">
                  <DevDomainSwitcher />
                </NavItem>
              )}
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const programs = state.auth.programs || [];
  const name = state.menu.data && state.menu.data.name;
  return {
    isAuthenticated: state.auth.token !== null,

    username: name,
    luxmed:
      state.auth.user.programId === 'f1912316-3516-44a0-b58b-4c24b584f486',
    hasPrograms: programs.length > 1 ? true : false,
    menu: state.menu.data && state.menu.data.menu ? state.menu.data.menu : []
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
